import React from 'react';
import { HelpCircle, MessageCircle } from 'lucide-react';
import { getThemeColor } from '../config/appConfig';
import { WHATSAPP_URL } from '../components/common/WhatsAppChatButton';

const THEME = getThemeColor('primary');

const openWhatsApp = () => {
  window.open(WHATSAPP_URL, '_blank', 'noopener,noreferrer');
};

const Support = () => (
  <div className="min-h-full bg-[#F4F6F9] px-4 sm:px-6 py-5 sm:py-6">
    <div className="max-w-2xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <div
          className="w-11 h-11 rounded-xl flex items-center justify-center text-white"
          style={{ backgroundColor: THEME }}
        >
          <HelpCircle className="w-6 h-6" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Support</h1>
          <p className="text-sm text-gray-500">Get help with your partner account</p>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm space-y-4">
        <p className="text-sm text-gray-600">
          Questions about commissions, payouts, or your partner account? Our support team is here to help.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            type="button"
            className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold text-white hover:opacity-90 transition"
            style={{ backgroundColor: THEME }}
            onClick={openWhatsApp}
          >
            <MessageCircle className="w-4 h-4" />
            Live Chat
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default Support;
